'use strict';

import dot from "dot";
import { initCarousel } from '../../../_scripts/helpers';

export default class RecommendedFilms {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    this.endpoint = $selector.data('endpoint');
    this.id = $selector.data('id');
    this.$template = $("#recommendedFilmsTemplate").html();
    this.$list = $('.recommended-films__body [data-carousel]', this.$selector);

    this.carouselOptions = {
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    };

    this.resultCarousel = null;
    if(selfInit) this.init();
  }

  init() {
    let callback = (res) => {
      this.renderCarousel(res);
    }

    //Call API to retrieve list of data
    this.retrieveData({
      endpoint: this.endpoint,
      data: { id: this.id },
      callback: callback
    });
  }

  retrieveData({endpoint, data, callback}) {
    $.ajax({
      url: endpoint,
      //data: data,
      data: JSON.stringify(data),
      method: 'post',
      contentType: 'application/json',
      success: (res) => {
        callback(res);
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  renderCarousel(data) {
    let dotTemplate = dot.template(this.$template)(data.items);
    this.$list.html(dotTemplate);

    if (data.items.length > 0) {
      this.resultCarousel = initCarousel(this.$list, this.carouselOptions);

      let timer;
      $(window).on('resize.resultsCarousel', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if(this.resultCarousel) {
            this.resultCarousel.unslick();
            this.resultCarousel.slickInit();
          }
        }, 500);
      });
    }
  }
}
